import { Configuration } from '@h2/types';
import { 
  LanguageSettingsData, 
  WorkflowData, 
  WorkerAssignmentData 
} from '../../stores/useWorkPresetStore';

// 프리셋 생성 전용 Configuration 팩토리
export const createPresetCreationConfiguration = (): Configuration => ({
  id: 'preset-creation',
  title: '프리셋 생성',
  description: '새로운 작업 프리셋을 생성합니다.',
  sections: [
    {
      id: 'preset-info',
      title: '프리셋 기본 정보',
      description: '프리셋의 이름, 설명, 태그를 설정합니다.',
      fields: [
        {
          id: 'presetName',
          type: 'text',
          label: '프리셋 이름',
          value: '',
          placeholder: '예: 한영 번역 표준',
          validation: {
            rules: [
              {
                type: 'required',
                message: '프리셋 이름을 입력해주세요'
              },
              {
                type: 'maxLength',
                value: 100,
                message: '프리셋 이름은 100자 이내로 입력해주세요'
              }
            ]
          }
        },
        {
          id: 'presetDescription',
          type: 'textarea',
          label: '프리셋 설명',
          value: '',
          placeholder: '이 프리셋에 대한 설명을 입력하세요',
          validation: {
            rules: [
              {
                type: 'maxLength',
                value: 500,
                message: '프리셋 설명은 500자 이내로 입력해주세요'
              }
            ]
          }
        },
        {
          id: 'presetTags',
          type: 'simple-tags',
          label: '프리셋 태그',
          value: [],
          placeholder: '예시) 긴급작업, 고객사:하이브, 분야:교육'
        }
      ]
    },
    {
      id: 'language-settings',
      title: '언어 및 기본 정보',
      description: '작업의 언어와 기본 정보를 설정합니다.',
      fields: [
        {
          id: 'languageSettingsComponent',
          type: 'language-settings',
          label: '언어 설정',
          value: {
            sourceLanguage: '',
            targetLanguages: [],
            tags: [],
            memo: ''
          } as LanguageSettingsData,
          validation: {
            rules: [
              {
                type: 'custom',
                message: '원본언어와 최소 1개 이상의 번역언어를 선택해주세요',
                validator: (value: any) => {
                  return value?.sourceLanguage && value?.targetLanguages && value.targetLanguages.length > 0;
                }
              }
            ]
          }
        },
        {
          id: 'jobTags',
          type: 'simple-tags',
          label: '태그',
          value: [],
          placeholder: '예시) 긴급작업, 고객사:하이브, 분야:교육'
        }
      ]
    },
    {
      id: 'workflow-design',
      title: '워크플로 구성',
      description: 'Task 배치와 순서를 시각적으로 구성합니다.',
      fields: [
        {
          id: 'workflowComponent',
          type: 'workflow-configuration',
          label: '워크플로 설정',
          value: {
            taskNodes: [],
            connections: []
          } as WorkflowData,
          validation: {
            rules: [
              {
                type: 'custom',
                message: '최소 1개 이상의 Task를 추가해주세요',
                validator: (value: any) => {
                  return value?.taskNodes && value.taskNodes.length > 0;
                }
              }
            ]
          }
        }
      ]
    },
    {
      id: 'worker-assignment',
      title: '작업자 배정',
      description: '각 Task에 작업자 또는 작업그룹을 배정합니다.',
      fields: [
        {
          id: 'workerAssignmentComponent',
          type: 'worker-assignment',
          label: '작업자 배정',
          value: {
            assignmentMatrix: [],
            availableWorkers: [],
            availableGroups: []
          } as WorkerAssignmentData,
          validation: {
            rules: [
              {
                type: 'custom',
                message: '작업자 배정이 완료되었습니다',
                validator: () => true // 임시로 항상 유효하다고 설정
              }
            ]
          }
        }
      ]
    }
  ]
});
